export function composeClubMatch({ club, match_information }) {
    return {
      club_kit_id: null,
      club_season_id: club.team_id,
      created: 0,
      current_formation: club.latest_line_up,
      current_formation_matrix: [],
      extra_score: null,
      first_penalty_kick: null,
      formation: club.initial_line_up,
      formation_matrix: [],
      id: club.team_id,
      is_loser:
        club.side === "home"
          ? match_information.away_team_goals > match_information.home_team_goals
          : match_information.away_team_goals < match_information.home_team_goals,
      is_series_loser: null,
      is_series_winner: null,
      is_winner:
        club.side === "home"
          ? match_information.away_team_goals < match_information.home_team_goals
          : match_information.away_team_goals > match_information.home_team_goals,
      match_id: match_information.match_id,
      score: club.goals,
      shootout_score: +club.goals + +club.penalty_goals,
      side: club.role,
      updated: 0,
      fullName: club.team_name,
      shortName: club.team_short_name,
      abbreviation: club.team_three_letter_code,
      yearFounded: null,
    };
  }
  